import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Box, Text } from 'components/Wrapped';
import { formatNumberToPlaces } from 'utils/numbers';
import { PrettyNumberTZ } from 'components/Helpers';

import { withNamespaces } from 'react-i18next';

const BuyLimitInfo = ({ currency, maxOrderValue }) => {
  return (
    <Box pad="none" direction="row" justify="between" align="center">
      <Text color="#B4B6B7" size="11px" weight={500} style={{ lineHeight: '13px' }}>
        Макс. лимит покупки
      </Text>
      <Box pad="none" direction="row" gap="3px">
        <Text color="white" size="12px" weight={500} style={{ lineHeight: '15px' }}>
          {currency}
        </Text>
        <PrettyNumberTZ
          color="white"
          weight={500}
          size="12px"
          number={formatNumberToPlaces(maxOrderValue, 2)}
          style={{ lineHeight: '15px' }}
        />
      </Box>
    </Box>
  );
};

BuyLimitInfo.propTypes = {
  total: PropTypes.number,
};

BuyLimitInfo.defaultProps = {
  total: 0,
};

const mapStateToProps = ({ exchangeSettings }) => ({
  currencySettings: exchangeSettings.currencySettings,
});

export default withNamespaces()(connect(mapStateToProps)(BuyLimitInfo));
